import styles from './DesktopHeader.module.scss';
import { AnnouncementBar } from '../AnnouncementBar/AnnouncementBar';
import { Branding } from '../Branding/Branding';
import { CtaButton } from '../CtaButton/CtaButton';
import { NavigationMenu } from './NavigationMenu/NavigationMenu';

import type { HeaderData, HeaderMenuItem } from '../../types';

type DesktopHeaderProps = {
  variant?: HeaderData['variant'];
  brand: HeaderData['brand'];
  announcement?: HeaderData['announcement'];
  menuItems: HeaderMenuItem[];
  cta: { label: string; url: string } | null;
  // languageLabel: string;
  // languages: NonNullable<HeaderData['language']['options']>;
};

export function DesktopHeader({
  variant = 'default',
  brand,
  announcement,
  menuItems,
  cta,
  // languageLabel,
  // languages,
}: DesktopHeaderProps) {
  return (
    <header
      className={`${styles.header} interact-header interact-header--${variant}`}
      data-header-variant={variant}
      role="banner"
    >
      <AnnouncementBar announcement={announcement} />

      <div className={`${styles.innerWrapper} interact-header__row`}>
        <div className={styles.inner}>
          <div className={styles.branding}>
            <Branding brand={brand} variant={variant} />
          </div>

          <div className={styles.navigation}>
            <NavigationMenu items={menuItems} />
          </div>

          <div className={styles.actions}>
            {/**
             * Language switching disabled for now; preserving markup for future reference.
             *
             * <LanguageMenu label={languageLabel} options={languages} />
             */}

            {cta && <CtaButton label={cta.label} url={cta.url} />}
          </div>
        </div>
      </div>
    </header>
  );
}
